import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const FAQS = [{
  q: '¿Cómo recibo los ebooks?',
  a: 'El acceso es inmediato. Una vez confirmado el pago, recibirás un correo electrónico con un enlace seguro para acceder y descargar todo el material en formato PDF de alta calidad.'
}, {
  q: '¿Sirven para principiantes?',
  a: '¡Absolutamente! Todas las recetas están explicadas paso a paso, de forma clara y sencilla. No necesitás experiencia previa en la cocina para lograr platos increíbles.'
}, {
  q: '¿Puedo imprimirlos?',
  a: 'Sí, el formato PDF está optimizado tanto para lectura digital (celular, tablet, PC) como para impresión. Podés imprimir tus recetas favoritas o las listas de compras.'
}, {
  q: '¿Necesito ingredientes especiales?',
  a: 'No. Una de nuestras principales premisas es utilizar ingredientes reales, comunes y fáciles de conseguir en cualquier supermercado o verdulería local.'
}, {
  q: '¿Qué medios de pago puedo usar?',
  a: 'Podés pagar de forma 100% segura con Mercado Pago y con tarjetas Visa, Mastercard y American Express (crédito y débito).'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-485">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-486">
        <div className="text-center mb-16" data-id="element-487">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-4 tracking-tight" data-id="element-488">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-ink-light font-light" data-id="element-489">
            Todo lo que necesitás saber antes de empezar tu transformación.
          </p>
        </div>

        <div className="space-y-4" data-id="element-490">
          {FAQS.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-cream rounded-2xl shadow-sm border border-ink/5 overflow-hidden" data-id="element-491">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-6 flex items-center justify-between text-left focus:outline-none" data-id="element-492">
                  <span className="font-bold text-ink pr-8 text-lg" data-id="element-493">
                    {faq.q}
                  </span>
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors flex-shrink-0 ${isOpen ? 'bg-combo-green text-white' : 'bg-white text-ink-light shadow-sm'}`} data-id="element-494">
                    <ChevronDown className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-495" />
                  </div>
                </button>
                <AnimatePresence data-id="element-496">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-497">
                      <div className="px-6 pb-6 text-ink-light leading-relaxed font-light text-lg" data-id="element-498">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}